/**
 * User routes.
 */

export const userRoutes = [
  // Change password page
  {
    path: "/user/change-password",
    name: "changePassword",
    component: () => import(/* webpackChunkName: "changePassword" */ "@/views/User/ForcePasswordChange.vue"),
    meta: {
      role: "none",
      title: { title: "banner_title_force_password_change", titleTranslated: false, subtitle: "" },
      allowWhenForcePasswordChange: true,
    },
  },

  // Redirect old MSI registration path to the new common user registration path.
  // Note meta.role isn't really needed here. Included for completeness.
  { path: "/msi/register", redirect: { name: "userRegister" }, meta: { role: "all" } },
  // User self-registration sign-up page
  {
    path: "/user/register/:data?",
    name: "userRegister",
    component: () => import(/* webpackChunkName: "userRegister" */ "@/views/User/UserRegister.vue"),
    meta: {
      // sites: ["msiglobalacademy.org", "firmacademy-dev.co.uk"],
      role: "loggedout",
      banner: false,
    },
  },
  // Verirication step for user self-registration
  {
    path: "/user/register/verify/:data?",
    name: "userRegisterVerify",
    component: () => import(/* webpackChunkName: "userRegisterVerify" */ "@/views/User/RegisterVerify.vue"),
    meta: {
      // sites: ["msiglobalacademy.org", "firmacademy-dev.co.uk"],
      role: "loggedout",
      banner: false,
    },
  },
  // Allow users to join groups when they self-register on the site
  {
    path: "/user/register/groups/:code",
    name: "userRegisterGroups",
    component: () => import(/* webpackChunkName: "userRegisterGroups" */ "@/views/User/RegisterGroups.vue"),
    meta: {
      role: "loggedout",
      banner: false,
    },
  },

  // PDL
  {
    path: "/user/pdl",
    name: "userProfessionalDevelopmentLog",
    component: () =>
      import(/* webpackChunkName: "userProfessionalDevelopmentLog" */ "@/views/User/ProfessionalDevelopmentLog.vue"),
    meta: {
      role: "none",
      banner: { image: "pdl", height: "short" },
    },
  },
  {
    path: "/user/group-leader",
    name: "userGroupLeaderLog",
    component: () => import(/* webpackChunkName: "userGroupLeaderLog" */ "@/views/User/GroupLeaderLog.vue"),
    meta: {
      role: "none",
      banner: { image: "pdl", height: "short" },
    },
  },
  {
    path: "/user/pdl-inline-log-entry/:collectionId/:contentId",
    name: "userPdlInlineLogEntry",
    component: () => import(/* webpackChunkName: "userGroupLeaderLog" */ "@/views/User/PdlInlineLogEntry.vue"),
    meta: {
      role: "none",
      contentOnly: true,
    },
  },

  // Login or register page
  {
    path: "/user/login-or-register",
    name: "userLoginOrRegister",
    component: () => import(/* webpackChunkName: "userLoginOrRegister" */ "@/views/User/LoginOrRegister.vue"),
    meta: {
      role: "loggedout",
      banner: { height: "short", class: "user-login-or-register" }, // set banner url manually in CSS
      title: { title: "banner_title_login_or_register", titleTranslated: false, subtitle: "" },
    },
  },

  // Group preview page - routes users as needed depending on whether they are logged in, etc
  {
    path: "/user/preview/:groupId",
    name: "userPreview",
    component: () => import(/* webpackChunkName: "userPreview" */ "@/views/User/UserPreview.vue"),
    meta: {
      role: "all",
      // banner: { image: "content", height: "short" },
      title: { title: "", titleTranslated: true, subtitle: "" }, // was banner_title_preview
    },
  },

  // Stripe payment callback (requires payments on)
  {
    path: "/user/payment-confirmation",
    name: "paymentConfirmation",
    component: () => import(/* webpackChunkName: "paymentCallback" */ "@/views/User/PaymentCallback.vue"),
    meta: {
      role: "none",
      payment: true,
      banner: { image: "content", height: "short" },
      title: { title: "banner_title_payment_callback", titleTranslated: false, subtitle: "" },
    },
  },

  // Redeem token (requires payments on)
  {
    path: "/user/account-redeem-token",
    name: "accountRedeemToken",
    component: () => import(/* webpackChunkName: "accountRedeemToken" */ "@/views/User/AccountRedeemToken.vue"),
    meta: {
      role: "none",
      payment: true,
      contentOnly: true,
    },
  },

  // View all currently logged-in user's payments (requires payments on)
  {
    path: "/user/account-payment-history",
    name: "accountPaymentHistory",
    component: () => import(/* webpackChunkName: "accountPaymentHistory" */ "@/views/User/AccountPaymentHistory.vue"),
    meta: {
      role: "none",
      payment: true,
      contentOnly: true,
    },
  },
];
